import { DictMap, DynamicFormItemProps } from "../components/DynamicForm/DynamicForm";
import { Icon } from "@/components/Icon";
import { DialogLocal } from "@/components/Dialog";
import { NavigateFunction } from "react-router-dom";
export const formItems: DynamicFormItemProps[] = [{
  fieldLabel: '币种',
  fieldName: 'paymentType',
  fieldType: '3',
  extra: <Icon name={'exchange'} size={'0.18rem'} />
}, {
  fieldLabel: '主网',
  fieldName: 'mainNet',
  fieldType: '1',
  readOnly: true
}, {
  fieldLabel: '钱包地址',
  fieldName: 'address',
  fieldType: 'CopyIcon',
  readOnly: true
}, {
  fieldLabel: '购买V币数量',
  fieldName: 'amount',
  fieldType: '2'
}, {
  fieldLabel: ({
    data
  }) => data.paymentType ? `${data.paymentType}价格：￥${data.otcTicker}` : `汇率：￥0.00`,
  fieldName: 'current',
  fieldType: 'Current',
  readOnly: true
}];
export const changeUsdtFormItems: DynamicFormItemProps[] = [{
  fieldLabel: '兑换币种',
  fieldName: 'paymentType',
  fieldType: '3',
  extra: <Icon name={'exchange'} size={'0.18rem'} />
}, {
  fieldLabel: '主网',
  fieldName: 'mainNet',
  fieldType: '1',
  readOnly: true
}, {
  fieldLabel: '收U地址',
  fieldName: 'receivingAddress',
  fieldType: '3',
  extra: <Icon name={'exchange'} size={'0.18rem'} />,
  initialProps: {
    noDataFun: (navigate: NavigateFunction) => {
      DialogLocal({
        title: "提示",
        content: "您还未绑定USDT钱包地址",
        confirmText: "去绑定",
        cancelText: "取消",
        onConfirm() {
          navigate("/payment", {
            replace: true
          }); //跳转至添加支付方式页面
          return Promise.resolve(true);
        },
        onCancel: () => {
          return Promise.resolve(true);
        }
      });
    }
  }
}, {
  fieldLabel: '出售V币数量',
  fieldName: 'amount',
  fieldType: '2'
}, {
  fieldLabel: ({
    data
  }) => data.paymentType ? `${data.paymentType}价格：￥${data.otcTicker}` : `汇率：￥0.00`,
  fieldName: 'current',
  fieldType: 'Current',
  readOnly: true
}];
export const dictMap: DictMap = {
  paymentType: [[{
    value: "USDT",
    text: 'USDT'
  }
  // {value: "TRX",text: 'TRX'},
  ]],
  receivingAddress: []
};